import React from 'react';
import './therapies.css';

import imageAcupuncture from "./images/acupucture.jpg";
import imageFrequency from "./images/frequency.jpg";
import imageBiokybernetic from "./images/biokybernetic.png";
import imageFood from "./images/food.jpg";
import imageMassage from "./images/massage.jpg";


const Therapies = () => {
return(
<div className="section sectionBackground" id="therapies">
<div className="viewport">
                                <h1>Therapien</h1>
                                <p className="sectionLead">
                                    Diese Methoden setze ich ein, um Sie bei Beschwerden zu begleiten. Im Erstgespr&auml;ch kl&auml;ren wir gemeinsam,
                                    was f&uuml;r Sie sinnvoll ist.
                                </p>
                                <div className='grid'>
                                    <div className='item'>
                                        <div className='image' style={{backgroundImage: `url(${imageAcupuncture})`}} />
                                        <h3>Traditionelle Chinesische Medizin</h3>
                                        <p>Wird h&auml;ufig begleitend eingesetzt, um Balance und Wohlbefinden zu f&ouml;rdern.</p>
                                    </div>
                                    <div className='item'>
                                        <div className='image' style={{backgroundImage: `url(${imageFrequency})`}} />
                                        <h3>Frequenztherapie</h3>
                                        <p>Sanfte, individuell abgestimmte Impulse zur Unterst&uuml;tzung der Regulation.</p>
                                    </div>
                                    <div className='item'>
                                        <div className='image' style={{backgroundImage: `url(${imageBiokybernetic})`, backgroundSize: `90%`}} />
                                        <h3>Biokybernetik nach Smit</h3>
                                        <p>Zur Unterst&uuml;tzung von Selbstregulation und Reizverarbeitung.</p>
                                    </div>
                                    <div className='item'>
                                        <div className='image' style={{backgroundImage: `url(${imageFood})`}} />
                                        <h3>Ern&auml;hrungsberatung</h3>
                                        <p>Alltagstaugliche Empfehlungen, die zu Ihren Zielen und Routinen passen.</p>
                                    </div>
                                    <div className='item'>
                                        <div className='image' style={{backgroundImage: `url(${imageMassage})`}} />
                                        <h3>Massage</h3>
                                        <p>Zur Entspannung, Lockerung und wohltuenden Unterst&uuml;tzung.</p>
                                    </div>
                                    <div className='item'>
                                        <div className='image' />
                                        <h3>Hautanomalien</h3>
                                        <p>Behandlung von Hautanomalien (Phlebolyser&reg;) nach individueller Abkl&auml;rung.</p>
                                    </div>
                                </div>
                        </div>

</div>
)
}
export default Therapies;